import * as base from './base.jsx';
import * as dateFilter from './dateFilter.jsx';

class DateHeader extends base.FilteredComponent {
  componentWillMount() {
    super.componentWillMount();
    radio("filterInitialized").subscribe(this.filterInitialized.bind(this));
  }

  filterInitialized(filter) {
    this.setState({
      dates: filter.serializeFilter(filter.state)
    });

    //Because this is a one filter only job,
    //here we can transmit that we are finished
    var filters = {};
    filters[filter.props.filterKey] = filter.serializeFilter(filter.state);
    radio("filtersFinishedInitialized").broadcast(filters);
  }

  handleFiltersChanged(filters) {
    this.setState({
      dates: filters.created
    });
  }

  render() {
    return <div className="date-header">
      <header className="clearfix">
        <h1 className="title">{ this.props.title.trim() + " " }</h1>
        <dateFilter.DateFilter />
      </header>
    </div>
  }
}

module.exports = {
  DateHeader: DateHeader
}
